import React, { createContext, useContext, useMemo } from "react";

import type { WithChildren } from "../../../_metronic/helpers";
import { useMediaQuery } from "../../hooks/useMediaQuery";

type MediaQueryType = "isSm" | "isMd" | "isLg" | "isXl";

type MediaQueryProviderType = Record<MediaQueryType, boolean>;

const MediaQueryContext = createContext<MediaQueryProviderType>({
  isSm: false,
  isMd: false,
  isLg: false,
  isXl: false,
});

const MediaQueryProvider: React.FC<WithChildren> = ({ children }) => {
  const isSm = useMediaQuery("sm");
  const isMd = useMediaQuery("md");
  const isLg = useMediaQuery("lg");
  const isXl = useMediaQuery("xl");

  const value = useMemo(() => {
    return {
      isSm,
      isMd,
      isLg,
      isXl,
    };
  }, [isSm, isMd, isLg, isXl]);

  return (
    <MediaQueryContext.Provider value={value}>
      {children}
    </MediaQueryContext.Provider>
  );
};

const useMediaQueryContext = () => {
  const { isSm, isMd, isLg, isXl } = useContext(MediaQueryContext);

  return {
    isSm,
    isMd,
    isLg,
    isXl,
  };
};

export { MediaQueryProvider, useMediaQueryContext };
